// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/wake-turbulence-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/wake-turbulence-procedures/wake-turbulence-procedures.js';

mount([g0]);
